<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-monitoring-attendance'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-monitoring-attendance"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(code)="data">
            <div class="d-flex">
              <div class="pt-1">
                <feather-icon
                  v-if="data.item.personal_type == 'Driver'"
                  icon="TruckIcon"
                  size="22"
                  class="text-warning"
                />
                <feather-icon
                  v-else
                  icon="UserIcon"
                  size="22"
                  class="text-success"
                />
              </div>
              <div class="ml-1">
                <span> {{ data.item.personal_name | capitalize }} </span> <br />
                <span style="opacity: 0.5"> #{{ data.item.code }} </span>
              </div>
            </div>
          </template>
          <template #cell(is_viatic)="data">
            <b-badge
              pill
              :variant="`light-${data.value == 'Apply' ? 'success' : 'danger'}`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(entity_group_name)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(dl_count)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  6,
                  data.item.dl_count,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
          <template #cell(fa_count)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  3,
                  data.item.fa_count,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
          <template #cell(ps_count)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  5,
                  data.item.ps_count,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
          <template #cell(to_day_hour)="data">
            <b-badge
              @click="todayRecord(data.item.id, data.item.to_day, data.item)"
              pill
              :variant="`light-${homeworkStatusVariant(
                data.item.homework_status_id
              )}`"
              :class="{ 'cursor-pointer': data.item.to_day != null }"
            >
              <span v-if="data.item.to_day != null">
                {{ data.item.abbreviation }} - {{ data.item.to_day }}</span
              >
              <span v-else>Pendiente</span>
            </b-badge>
            <br />
            <span class="" style="opacity: 0.6; margin-left: 4px">
              {{ data.item.description | capitalize }}
            </span>
            <b-badge v-if="data.item.is_sold_today == 1" pill variant="light-warning" class="ml-1" style="font-size: 0.7rem;" v-b-tooltip.hover title="Este día libre ha sido comprado">
              <feather-icon icon="DollarSignIcon" size="12" /> Día Vendido
            </b-badge>
          </template>
          <template #cell(observation)="data">
            <read-more
              v-if="data.value != 'null' && data.value != null"
              class="text-uppercase"
              :more-str="$t('read more ...')"
              :less-str="$t('read less ...')"
              :text="data.value"
              link="#"
              :max-chars="25"
              style="opacity: 0.7"
            ></read-more>
          </template>
          <template #cell(id)="data">
            <feather-icon
              @click="setAttendance(data.item)"
              icon="CalendarIcon"
              size="17"
              class="cursor-pointer text-success"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AttendanceDetailsByStatus
      v-if="attendanceDetailsByStatus"
      :dataModal="dataModal"
      @hideModal="hideAttendanceDetailsByStatus"
    />

    <PersonalAttendance
      v-if="personalAttendance"
      :dataModal="dataModal"
      @hideModal="hidePersonalAttendance"
    />

    <!-- <b-button @click="process">Process</b-button>
    <b-button @click="send">Send</b-button>
    <pre>
      {{ items }}
    </pre> -->
    <!-- <b-table :items="items" small responsive> </b-table> -->
  </div>
</template>

<script>
/* Data */
import Fields from "@/views/monitoring/views/attendance/data/Fields.data.js";
// import FilterReportSlot from "@/views/commons/filter-slot/FilterReportSlot.vue";
// import Usuarios from "./personal_entity_group.json";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* DATA */
import FilterData from "@/views/monitoring/views/attendance/data/Filters.data.js";

/* Modals */
import AttendanceDetailsByStatus from "@/views/monitoring/views/attendance/components/modals/AttendanceDetailsByStatus.vue";
import PersonalAttendance from "@/views/monitoring/views/attendance/components/modals/PersonalAttendance.vue";

/* Services */
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";
import { mapGetters } from "vuex";

export default {
  components: {
    FilterSlot,
    AttendanceDetailsByStatus,
    PersonalAttendance,
  },
  data() {
    return {
      filters: FilterData,
      // items: Usuarios,
      params: 1,
      fields: Fields,
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      attendanceDetailsByStatus: false,
      personalAttendance: false,
      dataModal: {},
    };
  },
  computed: {
    showFields() {
      return Fields.map((item) => ({ ...item, label: this.$t(item.label) }));
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {},
  methods: {
    /*async send() {
      try {
        const data = await AttendanceService.insertMat({
          tracking: JSON.stringify(this.items),
        });
        console.log("Response: ", data);
      } catch (error) {
        console.log(error);
      }
    },
    process() {
      const personals = [];

      this.items.forEach((row) => {
        const persona = {
          id: row.id,
          subgrupo: row.id_subgrupo_personal,
        };

        personals.push(persona);
      });
      this.items = personals;
    },*/

    async myProvider(ctx) {
      try {
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          personal_type:
            this.filters[0].model != null ? this.filters[0].model : 2,
          is_viatic: this.filters[1].model != null ? this.filters[1].model : 0,
          user_id: this.currentUser.id,
          role_id: this.currentUser.role_id,
        };
        const { data } = await AttendanceService.getDailyAttendance(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    homeworkStatusVariant(homework_status_id) {
      if (homework_status_id == null) return "default";
      if (homework_status_id === 3) return "danger";
      if (homework_status_id === 4) return "warning";
      if (homework_status_id === 1 || homework_status_id === 2)
        return "success";
      if (homework_status_id === "inactive") return "secondary";
      return "primary";
    },
    countHomeworkStatusVariant(count) {
      if (count === 0) return "success";
      if (count > 0 && count <= 3) return "warning";
      return "danger";
    },
    todayRecord(attendance_id, today, item) {
      this.dataModal = {
        attendance_id,
        personal_name: item.personal_name,
        code: item.code,
        today,
      };
      this.attendanceDetailsByStatus = true;
    },
    getAttendanceDetailsByStatus(
      attendance_id,
      homework_status_id,
      count,
      item
    ) {
      if (count == 0) return;
      this.dataModal = {
        attendance_id,
        homework_status_id,
        personal_name: item.personal_name,
        code: item.code,
      };
      this.attendanceDetailsByStatus = true;
    },
    hideAttendanceDetailsByStatus() {
      this.attendanceDetailsByStatus = false;
    },
    setAttendance(item) {
      this.dataModal = item;
      this.dataModal.origin = "attendance";
      this.personalAttendance = true;
    },
    hidePersonalAttendance(action = false) {
      if (action == true) {
        this.$refs["ref-table-monitoring-attendance"].refresh();
      }
      this.personalAttendance = false;
    },
  },
};
</script>

<style>
</style>